// src/components/ToastContainer.jsx

import React from 'react';
import Toast from '../Toast/index.js';
import './index.scss';

export default function ToastContainer({ toasts, removeToast }) {
  return (
    <div className="toast-container">
      {toasts.map(({ id, message, type, duration }) => (
        <Toast
          key={id}
          id={id}
          message={message}
          type={type}
          duration={duration}
          onClose={() => removeToast(id)}
        />
      ))}
    </div>
  );
}